export const refs = {
headerForm: document.querySelector('.header-form'),
};